import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptors, withXsrfConfiguration } from '@angular/common/http';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { AuthModule } from './pages/auth/auth.module';
import { AppRoutingModule } from './app-routing.module';
import { authInterceptor } from './core/auth/interceptors/request.auth.interceptor';
import { errorInterceptor } from './core/auth/interceptors/error.interceptor';
import { mockBffInterceptor } from './core/auth/interceptors/mock-bff.interceptor';
import { loadingInterceptor } from './shared/interceptors/loading.interceptor';
import { corporateHeadersInterceptor } from './core/interceptors/corporate-headers.interceptor';
import { environment } from '../environments/environment';

import { csrfInterceptor } from './core/auth/interceptors/request.csrf.interceptor';
import { recaptchaInterceptor } from './core/captcha/score/recaptcha.interceptor';
import { checkboxRecaptchaInterceptor } from './core/captcha/checkbox/checkbox-recaptcha.interceptor';


// BUG FIX #1: Single provideHttpClient with ALL interceptors (archetype had two that overwrote each other)
// Removed eager HomeModule and FeatureModule imports (they break lazy loading)

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    AuthModule,
    AppRoutingModule,
    // NO HomeModule, NO FeatureModule (lazy loaded via router)
  ],
  providers: [
    provideHttpClient(
      withFetch(),
      withXsrfConfiguration({
        cookieName: environment.CSRF.COOKIE_NAME,
        headerName: environment.CSRF.HEADER_NAME
      }),
      withInterceptors([
        mockBffInterceptor,
        corporateHeadersInterceptor,
        authInterceptor,
        errorInterceptor,
        loadingInterceptor,
        //csrfInterceptor,
        //recaptchaInterceptor,
        //checkboxRecaptchaInterceptor,
      ])),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
